export function Footer() {
    return (
        <footer>
            <div className="container justify-center">
                <p>Final Project of ISDI Coders Bootcamp by Michael Damiani</p>
            </div>
        </footer>
    );
}
